import React from "react";
import { formatIdDateTime } from "@/lib/format";
import { AuditCategoryBadge } from "@/lib/auditCategories";

/** Single row + expandable meta pane. */
export default function AuditRow({ item, expanded, onToggle }) {
  const hasMeta = item.meta && Object.keys(item.meta).length > 0;
  const isFraud = item.action === "spb.verify_failed";

  return (
    <>
      <tr
        className={`border-b border-border hover:bg-secondary/30 cursor-pointer ${isFraud ? "bg-red-50/50" : ""}`}
        onClick={onToggle}
        data-testid={`audit-row-${item.id}`}
      >
        <td className="p-3 font-mono text-xs whitespace-nowrap">
          {formatIdDateTime(item.created_at)}
        </td>
        <td className="p-3">
          <AuditCategoryBadge action={item.action} />
        </td>
        <td className="p-3 font-mono text-xs">{item.action}</td>
        <td className="p-3 text-xs">{item.user_email}</td>
        <td className="p-3 font-mono text-xs truncate max-w-[16ch]">{item.target || "-"}</td>
        <td className="p-3 text-xs text-right">
          {hasMeta ? (
            <span className="text-primary underline">{expanded ? "tutup" : "lihat"}</span>
          ) : (
            <span className="text-muted-foreground">—</span>
          )}
        </td>
      </tr>
      {expanded && hasMeta && (
        <tr className="bg-secondary/20 border-b border-border">
          <td colSpan={6} className="p-4">
            <div className="text-xs overline mb-2">Detail Meta</div>
            <dl className="grid grid-cols-1 md:grid-cols-2 gap-2 text-xs">
              {Object.entries(item.meta).map(([k, v]) => (
                <div key={k} className="flex gap-2">
                  <dt className="font-bold min-w-[10ch] uppercase text-muted-foreground">{k}</dt>
                  <dd className="font-mono break-all">
                    {typeof v === "object" ? JSON.stringify(v) : String(v)}
                  </dd>
                </div>
              ))}
            </dl>
          </td>
        </tr>
      )}
    </>
  );
}
